import { httpClient } from './http-client'
import type { AxiosRequestConfig } from 'axios'

export abstract class BaseService {
  constructor(protected readonly basePath: string) {}

  protected async get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    const response = await httpClient.get<T>(`${this.basePath}${url}`, config)
    return response.data
  }

  protected async post<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> {
    const response = await httpClient.post<T>(`${this.basePath}${url}`, data, config)
    return response.data
  }

  protected async put<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> {
    const response = await httpClient.put<T>(`${this.basePath}${url}`, data, config)
    return response.data
  }

  protected async patch<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> {
    const response = await httpClient.patch<T>(`${this.basePath}${url}`, data, config)
    return response.data
  }

  protected async delete<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    const response = await httpClient.delete<T>(`${this.basePath}${url}`, config)
    return response.data
  }
}
